<script>

	import ArticleOverview from '@/components/ArticleOverview'
	import BlogishEntries from '@/components/BlogishEntries'
	import Fragment from '@/components/Fragment'
	import Logo from './Logo'
	import { head, tail } from 'lodash'

	export default {
		metaInfo () {
			return this.$generateMetaInfo({
				title: `The Daily Sync`,
				description: `Learn. Create. Connect. The Daily Sync is a collection of free lesson resources inspired by StudySync’s Core Curriculum for middle and high school students. This offering invites guest educators to try on StudySync’s dynamic, media-rich instruction. We’re thrilled that you’re here.`,
				image: 'https://d3pnpeso9ssknc.cloudfront.net/blog/7928/chicago.jpg'
			})
		},
		render () {
			return (
				<BlogishEntries
					variables={{
						section: 'theDailySync'
					}}
					render={({ ready, entries }) => {
						if(!ready) {
							return null
						}
						return (
							<ArticleOverview
								featured={() => (
									<ArticleOverview.Featured
										entry={head(entries)}
										entryName="theDailySyncEntry"
										render={({ entry, Prehead, Title, Intro, Cta }) => (
											<div class="featured">
												<Logo centered={this.$mq.mobile} class="theDailySyncLogo" />
												<div>
													<Prehead>{entry.category}</Prehead>
													<Title>{entry.title}</Title>
													<Intro domPropsInnerHTML={entry.intro} />
													<Cta>View The Daily Sync</Cta>
												</div>
											</div>
										)}
									/>
								)}
								intro={() => (
									<div class="intro">
										<h2 class="welcome">Welcome to The Daily Sync</h2>
										<div>
											<p>Learn. Create. Connect. The Daily Sync is a collection of free lesson resources inspired by StudySync’s Core Curriculum for middle and high school students. This offering invites guest educators to try on StudySync’s dynamic, media-rich instruction. We’re thrilled that you’re here.</p>
										</div>
									</div>
								)}
								listings={() => (
									<Fragment>
										<container>
											<h2 class="episodes">More Daily Syncs</h2>
										</container>
										<ArticleOverview.Listings
											entries={tail(entries)}
											entryName="theDailySyncEntry"
											meta={(entry) => entry.category}
											watermark={() => (
												<Logo class="watermark" />
											)}
										/>
									</Fragment>
								)}
							/>
						)
					}}
				/>
			)
		}
	}

</script>

<style lang="scss" scoped>
	@import "media";
	.welcome,
	.episodes {
		font-weight:400; color:#000; text-transform:uppercase;
	}
	.welcome {
		margin-bottom:.75rem; font-size:3.4rem; line-height:1.2;
		@include media(large) {
			font-size:3.8rem;
		}
	}
	.intro {
		margin-bottom:3rem;
	}
	.episodes {
		margin-bottom:-5rem;
	}
	.theDailySyncLogo {
		margin-bottom:1.5rem;
	}
	.featured {
		@include media(large) {
			display:flex; align-items:flex-start; max-width:600px;
			.theDailySyncLogo {
				margin:0 2em 0 0; max-width:180px;
			}
		}
	}
	.watermark {
		position:absolute; top:5px; right:5px; max-width:50px !important;
	}
</style>



// WEBPACK FOOTER //
// src/routes/the-daily-sync/index.vue